import { render, staticRenderFns } from "./AdminEditUserModal.vue?vue&type=template&id=606b260e"
import script from "./AdminEditUserModal.vue?vue&type=script&lang=js"
export * from "./AdminEditUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports